import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-divider',
    templateUrl: './divider.component.html',
    styleUrls: ['./divider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DividerComponent implements OnInit {

    @Input('gap') gap: string;

    constructor() {
    }

    ngOnInit() {
    }
}
